import React from "react";
import history from "helper/history";

/*-------------Constant files import-----------------*/
import Api from "../constants/api";
import SSOList from "../constants/basicConfig";
// import Styles from "../constants/style";
import { CustomSnackbar as Snackbar, Loader } from "../customComponents/components";
/*-------------Other own component files------------------*/
import Login from "../components/login/loginpage";
import PasswordPage from "../components/login/passwordpage";
import MobileVerificationPage from "../components/login/mobileverificationpage";
import EmailVerificationPage from "../components/login/emailverificationpage";
import SetPassword from "../components/login/setpassword";
import RegistrationPage from "../components/login/registrationpage";
import MultiProfilePage from "../components/login/multiprofilepage";
import CantSignInPage from "../components/login/cantSignIn";
import VerifyEmailId from "../components/login/verifyemailid";
import SSOSiginPage from "../components/login/SSOSigninPage";

/*--------Store and actions files import-------------*/
import * as LoginAction from "../actions/loginaction";
import LoginStore from "../stores/loginstore";
import userInfoStores from "../stores/userInfoStores";
import Toaster from "../components/Toaster/toaster";

import i18n from "../i18nNext";

import ProductLogo from "../../public/assets/images/product-logo.svg";
import "../components/login/login.scss";

function checkIfLoggedIn() {
    const { hash = "" } = window.location;
    if (hash.includes("#")) {
        history.replace(hash.substring(1));
    } else {
        if (
            Api._getCookieValue("cid") &&
            Api._getCookieValue("token") &&
            Api._getCookieValue("org_id") &&
            Api._getCookieValue("viewType")
        ) {
            const { pathname } = window.location;
            if (pathname === "" || pathname === "/" || (pathname.includes("/login") && !pathname.includes("/login/gmail-addon"))) {
                Api._redirectToDashboard();
                return false;
            }
        }
    }
}

checkIfLoggedIn();

const breakPoints = {
    xs: 24,
    sm: 12,
    md: 8,
    lg: 7,
    xl: 6
};

const privacyPolicyUrl = "https://www.happay.in/privacy.html";
const termOfUseUrl = "https://www.happay.in/terms.html";

export default class LoginTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loginError: "",
            isSnackbarActive: false,
            showLoader: false,
            passOtp: "",
            isSSOLogin: SSOList.isSSO(),
            allCountryCode: []
        };
        this._init();
        this._handleLoginStore = this._handleLoginStore.bind(this);
        this._handleTimeoutSnackbar = this._handleTimeoutSnackbar.bind(this);
    }

    componentDidMount() {
        LoginAction.getCountryCodeTypeaheadAPI();
        LoginStore.on("change", this._handleLoginStore);
    }
    _init() {
        const value = checkIfLoggedIn();
        if (value === false) return false;
        // document.body.style.backgroundColor = "#16325c";
        const isSSO = SSOList.isSSO();
        const user = LoginStore._getField("user");

        const { loginTabs = "" } = this.props.match.params;
        if (loginTabs && loginTabs !== "verifyemail" && loginTabs !== "gmail-addon" && !user && !isSSO && loginTabs !== "sso") {
            Api._redirectToLogin(isSSO);
            return false;
        }
        if (loginTabs === "gmail-addon") {
            sessionStorage.setItem("hardware_id", Api.create_UUID());
            sessionStorage.setItem("gmail-addon-info", window.location.href);
        }
        const { search } = window.location;
        if (isSSO && !search.includes("logout")) {
            if (Api._getKey("cid") != 2) {
                LoginAction._checkSSO(); //check for sso validation
            } else {
                let pageName = "/login/registrationpage";
                history.push(pageName);
            }
        } else if (isSSO && search.includes("logout")) {
            Api._clearStorage();
        }
    }

    componentWillUnmount() {
        LoginStore.removeListener("change", this._handleLoginStore);
    }

    _handleLoginStore(type) {
        if (type == "errorMsg") {
            let msg = LoginStore._getField("errorMsg");
            if (msg) {
                userInfoStores.showToast(msg, 1);
            }
        } else if (type == "loader") {
            this.setState({
                showLoader: LoginStore._getLoader()
            });
        } else if (type == "passOtp") {
            this.setState({ passOtp: LoginStore._getStoredOtp() });
        }
        if (type == "countryCode") {
            let countryCodeList = LoginStore._getCountryCodeField() || [];
            countryCodeList.sort((a, b) => {
                return a.country > b.country ? 1 : b.country > a.country ? -1 : 0;
            });
            const allCountryCode = countryCodeList.map(unit => {
                return {
                    text: unit.country_code + "  " + unit.country.split("(")[0],
                    value: unit.country_code
                };
            });
            this.setState({ allCountryCode });
        }
    }

    _handleTimeoutSnackbar() {
        this.setState({
            isSnackbarActive: false,
            loginError: ""
        });
    }

    render() {
        let app;
        let { loginTabs = "", token } = this.props.match.params;
        const { search } = window.location;
        const { allCountryCode } = this.state;
        switch (loginTabs) {
            case "mobileverificationpage":
                app = (
                    <MobileVerificationPage
                        ProductLogo={ProductLogo}
                        breakPoints={breakPoints}
                        privacyPolicyUrl={privacyPolicyUrl}
                        termOfUseUrl={termOfUseUrl}
                    />
                );
                break;
            case "emailverificationpage":
                app = <EmailVerificationPage ProductLogo={ProductLogo} breakPoints={breakPoints} />;
                break;
            case "registrationpage":
                app = <RegistrationPage ProductLogo={ProductLogo} breakPoints={breakPoints} />;
                break;
            case "multiprofilepage":
                app = (
                    <MultiProfilePage
                        ProductLogo={ProductLogo}
                        breakPoints={breakPoints}
                        privacyPolicyUrl={privacyPolicyUrl}
                        termOfUseUrl={termOfUseUrl}
                    />
                );
                break;
            case "passwordpage":
                app = (
                    <PasswordPage
                        ProductLogo={ProductLogo}
                        allCountryCode={allCountryCode}
                        breakPoints={breakPoints}
                        privacyPolicyUrl={privacyPolicyUrl}
                        termOfUseUrl={termOfUseUrl}
                    />
                );
                break;
            case "setpassword":
                app = <SetPassword otpPass={this.state.passOtp} ProductLogo={ProductLogo} />;
                break;
            case "cantsignin":
                app = (
                    <CantSignInPage
                        ProductLogo={ProductLogo}
                        breakPoints={breakPoints}
                        privacyPolicyUrl={privacyPolicyUrl}
                        termOfUseUrl={termOfUseUrl}
                    />
                );
                break;
            case "verifyemail":
                app = (
                    <VerifyEmailId
                        ProductLogo={ProductLogo}
                        breakPoints={breakPoints}
                        token={token}
                    />
                );
                break;
            case "sso":
                app = (
                    <SSOSiginPage
                        allCountryCode={allCountryCode}
                        ProductLogo={ProductLogo}
                        breakPoints={breakPoints}
                        privacyPolicyUrl={privacyPolicyUrl}
                        termOfUseUrl={termOfUseUrl}
                        searchParams={search}
                    />
                );
                break;
            default:
                app = (
                    <Login
                        allCountryCode={allCountryCode}
                        ProductLogo={ProductLogo}
                        breakPoints={breakPoints}
                        privacyPolicyUrl={privacyPolicyUrl}
                        termOfUseUrl={termOfUseUrl}
                        searchParams={search}
                    />
                );
        }

        return (
            <div style={{ height: "100%" }}>
                {app}
                <Toaster className="loginToaster" />
                <Snackbar
                    open={this.state.isSnackbarActive}
                    message={this.state.loginError ? this.state.loginError : ""}
                    autoHideDuration={4000}
                    bodyStyle={{ maxWidth: "1500px" }}
                    onRequestClose={this._handleTimeoutSnackbar}
                />
                {this.state.showLoader ? (
                    <div style={Object.assign({ color: "#ffffff" })}>
                        <Loader />
                        {this.state.isSSOLogin ? <h4>{i18n.t("logIn.withSso")}</h4> : null}
                    </div>
                ) : null}
            </div>
        );
    }
}
